export const sx = {
    header: {
        width: '100%',
        '.lightTheme &': {
            backgroundColor: '#fff',
        },
        padding: '17px 0 3px',
        boxShadow: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    btn:{
        position:'absolute',
        right:'3px',
        top:'3px',
    }
}